import { Link } from "react-router-dom";
import { Box, Grid, TextField, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { pageRoutes } from "../../constants";
import { StepHeader, StepMessage, submitButtonSx } from "../../components/Auth/common";

export default function CredentialsStep({
  email,
  password,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  isSubmitting,
  error,
}) {
  function handleSubmit(event) {
    event.preventDefault();
    onSubmit();
  }

  return (
    <Box component="form" noValidate onSubmit={handleSubmit}>
      <StepHeader title="Welcome back!">Sign into your account below.</StepHeader>

      <TextField
        fullWidth
        type="email"
        name="email"
        label="Email"
        autoComplete="email"
        value={email}
        onChange={(event) => onEmailChange(event.target.value)}
        margin="dense"
        sx={{ mb: 2 }}
      />

      <TextField
        fullWidth
        type="password"
        name="password"
        label="Password"
        autoComplete="current-password"
        // Coming back from the code step keeps the email, so continue at the password
        autoFocus={Boolean(email)}
        value={password}
        onChange={(event) => onPasswordChange(event.target.value)}
        margin="dense"
        sx={{ mb: 1 }}
      />

      <StepMessage error={error} />

      <LoadingButton
        fullWidth
        type="submit"
        variant="contained"
        loading={isSubmitting}
        sx={{ ...submitButtonSx, mb: 4 }}
      >
        Login
      </LoadingButton>

      <Grid container justifyContent="space-between" sx={{ px: 1, color: "text.secondary" }}>
        <Typography variant="body2">
          <Link to={pageRoutes.REGISTER} style={{ textDecoration: "none" }}>
            Don’t have an account?
          </Link>
        </Typography>
        <Typography variant="body2">
          <Link to={pageRoutes.FORGOT_PASSWORD} style={{ textDecoration: "none" }}>
            Forgot your password?
          </Link>
        </Typography>
      </Grid>
    </Box>
  );
}
